import { SVGELEMENT } from '../../../../../enums/SVGELEMENT.js';
import SVGSHAPE from '../SVGSHAPE.js';
import { makeAttrStruct } from '../../../../../enums/ModelAttr.js';
import { makeStruct } from '../../../../../enums/MODELS.js';
// Model Structure
export const svgCircleAttr = makeAttrStruct([
    ['r'],
    ['cx', '0'],
    ['cy', '0'],
    ['fill', 'none'],
    ['stroke', 'currentColor'],
    ['style']
]);
export const svgCircleData = makeStruct();
export const svgCircleModel = makeStruct([
    ['attributes', svgCircleAttr],
    ['data', svgCircleData]
]);
// Simplified Model
export function svgCircle(attributes, data) {
    return {
        attributes: attributes || svgCircleAttr('100', '0', '0'),
        data: data || svgCircleData()
    };
}
/** Creates a Circle Shape for an SVG */
export default class SVGCIRCLE extends SVGSHAPE {
    constructor(node, model) {
        super(node, SVGELEMENT.CIRCLE, model);
    }
}
